// extracted by mini-css-extract-plugin
export default {"legend":"Fieldset_legend__2eGqg","fieldset":"Fieldset_fieldset__a3jAc"};